import React, { useEffect, useState } from 'react';
import { usePostgrest } from 'src/services/postgrest-provider';
import { RequestStatus } from "src/shared/enums";
import { EmailConfigIssue } from '../services/full-report';
import { EmailConfigIssues } from './EmailConfigIssues';

export const EmailConfigIssuesWithApi:React.FC = () => {
  const postgrest = usePostgrest();
  const [reqStatus, setReqStatus] = useState(RequestStatus.Pending);
  const [data, setData] = useState([] as EmailConfigIssue[]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getData(), []);

  const getData = () => {
    postgrest
      .GetTable('email_config_issues')
      .then((res) => {
        if (res.type === "success"){
          setReqStatus(RequestStatus.Success);
          setData(res.data);
        } else if (res.type === "error") {
          console.error(res.message);
          setReqStatus(RequestStatus.Error);
        }
      })
  }
  return (
    <EmailConfigIssues data={data} status={reqStatus} />
  )
}
